import * as React from "react";
import { forwardRef } from "react";
const SvgNotificationIconError = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", id: "prefix__ic_error", width: 24, height: 24, viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { id: "prefix__np_x_2147847_000000", d: "M9.739 11.087L6.367 7.716l-3.372 3.371a.953.953 0 1 1-1.348-1.348l3.371-3.373-3.371-3.372a.953.953 0 1 1 1.348-1.348l3.372 3.371 3.372-3.371a.953.953 0 1 1 1.348 1.348L7.716 6.366l3.371 3.372a.953.953 0 1 1-1.348 1.348z", transform: "translate(5.633 5.633)", style: {
  fill: "#da1e27"
} }), /* @__PURE__ */ React.createElement("g", { style: {
  stroke: "#da1e27",
  strokeWidth: 2,
  fill: "none"
} }, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 12, style: {
  stroke: "none"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 11, style: {
  fill: "none"
} })));
const ForwardRef = forwardRef(SvgNotificationIconError);
export { ForwardRef as ReactComponent };
